import { render, staticRenderFns } from "./bao-cao-loi-nhuan.vue?vue&type=template&id=7453c832&scoped=true&"
import script from "./bao-cao-loi-nhuan.vue?vue&type=script&lang=js&"
export * from "./bao-cao-loi-nhuan.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-loi-nhuan.vue?vue&type=style&index=0&id=7453c832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7453c832",
  null
  
)

export default component.exports